// extracted by mini-css-extract-plugin
export default {"container":"BaseToggle_container_XLWZU","disabled":"BaseToggle_disabled_QkRwI","peg":"BaseToggle_peg_ecC5Y","track":"BaseToggle_track_NTxc7","error":"BaseToggle_error_ZhXMZ"};